import React, { ReactElement } from "react";
import classnames from "classnames";

import { Button } from "../../button/Button";
import { ProgressStage, useFormContext } from "../formContext";

import "./FormSubmitButton.scss";

const Stages = {
  [ProgressStage.Processing]: (
    <div className="form-submit-button-loader">
      <span className="form-submit-button-loader__block" />
      <span className="form-submit-button-loader__block" />
      <span className="form-submit-button-loader__block" />
      <span className="form-submit-button-loader__block" />
      <span className="form-submit-button-loader__block" />
      <span className="form-submit-button-loader__block" />
    </div>
  ),
  [ProgressStage.Success]: (
    <span className="form-submit-button__icon fa-solid fa-check" />
  ),
  [ProgressStage.Error]: (
    <span className="form-submit-button__icon fa-solid fa-times" />
  ),
};

interface SuccessButtonProps {
  label: string | ReactElement;
  disabled: boolean;
}

export const FormSubmitButton = ({ label, disabled }: SuccessButtonProps) => {
  const { progressStage } = useFormContext();

  const nonDefaultStage = progressStage !== ProgressStage.Default;

  return (
    <Button
      className="form-submit-button"
      size="large"
      type="submit"
      color={progressStage !== ProgressStage.Error ? "primary" : "destructive"}
      disabled={disabled}
    >
      <span
        className={classnames({
          "form-submit-button__label--hidden": nonDefaultStage,
        })}
      >
        {label}
      </span>

      {nonDefaultStage && Stages[progressStage]}
    </Button>
  );
};
